module.exports = __webpack_public_path__ + "static/media/PD_02.4255fdd3.jpg";